import request, {
  handleResponse,
  handleThenable,
  handleError,
  headers,
} from "./index";

// import { instance_list, instance_close_open, mock_data } from "./mock";

// 获取通用算力
export const getMarketCommon = () => {
  return request
    .get("/api/market/common")
    .then(handleResponse)
    .then(
      handleThenable<{
        region: Array<{
          datacenter: string;
          name: string;
          region_id: string;
          used_for: string;
          visible: string;
        }>;
        sku_list: Array<{
          name: string;
          skuID: string;
        }>;
      }>
    )
    .catch(handleError);
};

// 获取gpu型号
export const getGpuSpec = (params: { region_id: "" }) => {
  return request
    .post("/api/market/region/gpu", params)
    .then(handleResponse)
    .then(
      handleThenable<
        Array<{
          gpu_type_id: string;
          idle: number;
          name: string;
          total: number;
          region_list: string[];
        }>
      >
    )
    .catch(handleError);
};

// 获取可用gpu列表
export const getGpuList = (
  page: {
    size: number;
    page: number;
  },
  params: {
    sku_id: string;
    region_id: string;
    gpu_num: number;
    gpu_type: string[];
    runtime_type: string;
  }
) => {
  return request
    .post("/api/market/machine/list", params, {
      params: page,
    })
    .then(handleResponse)
    .then(
      handleThenable<{
        pagination: {
          page: number;
          size: number;
          total: number;
        };
        result: Array<Record<string, any>>;
      }>
    )
    .catch(handleError);
};

// 获取机器详情

export const getGpuDetail = (params: { machine_id: string }) => {
  return request
    .post("/api/market/machine/detail", params)
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 实例列表

export const getInstanceList = (
  params: any,
  query: { page: number; size: number }
) => {
  return request
    .post("/api/instance/list", params, {
      params: query,
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取实例详情

export const getInstanceDetail = (params: { instance_id: string }) => {
  return request
    .post("/api/instance/detail", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 关机

export const postCloseInstance = (params: { instance_id: string }) => {
  // return mock_data(instance_close_open, 2000)
  //   .then(handleThenable)
  //   .catch(handleError)
  //   .then((res) => {
  //     instance_list.data.result[0].status = "close";
  //     return res;
  //   });
  return request
    .post("/api/instance/stop", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 开机

export const postOpenInstance = (params: { instance_id: string }) => {
  // return mock_data(instance_close_open, 2000)
  //   .then(handleThenable)
  //   .catch(handleError)
  //   .then((res) => {
  //     instance_list.data.result[0].status = "running";
  //     return res;
  //   });
  return request
    .post("/api/instance/start", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 释放实例

export const postReleaseInstance = (params: { instance_id: string }) => {
  // return mock_data(instance_close_open, 2000)
  //   .then(handleThenable)
  //   .catch(handleError)
  //   .then((res) => {
  //     instance_list.data.result[0].status = "running";
  //     return res;
  //   });
  return request
    .post("/api/instance/release", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 自动续费

export const postAutoRenewInstance = (params: {
  instance_id: string;
  auto_renew: "auto" | "manual";
}) => {
  return request
    .post("/api/instance/auto/renew", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 创建实例

export const postCreateInstance = (params: {
  instance_info: Record<string, string | number | undefined>;
  price_info: Record<string, string | number | undefined | number[]>;
}) => {
  // return mock_data(instance_close_open, 2000)
  //   .then(handleThenable)
  //   .catch(handleError)
  return request
    .post("/api/instance/create", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取镜像列表
export const getImageBaseList = () => {
  return request
    .post("/api/market/image/list")
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 用户余额
export const getBalanceInfo = () => {
  return request
    .post("/api/order/user/balance", null, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 我的订单
export const getMyOrderList = (
  query: {
    page: number;
    size: number;
  },
  params?: {
    instance_id: string;
    date_from: string;
    date_to: string;
  }
) => {
  return request
    .post("/api/order/user/list", params, {
      headers,
      params: query,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 订单详情
export const getMyOrderDetail = (params: { order_id: string }) => {
  return request
    .post("/api/order/user/detail", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 公共数据
export const getCommonData = (query: { page: number; size: number }) => {
  return request
    .get("/api/dateset/list", {
      headers,
      params: query,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 保存我的镜像
export const postMyMirrorData = (params: {
  image_name: string;
  instance_id: string;
}) => {
  return request
    .post("/api/instance/image/save", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 扩缩容
export const postSwellData = (params: {
  target_disk_size: number;
  instance_id: string;
}) => {
  return request
    .post("/api/instance/disk/resize", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 容量预览
export const getSwellData = (params: {
  instance_id: string;
}) => {
  return request
    .post("/api/instance/disk/preview", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 删除我的镜像
export const deleteMyMirrorData = (params: { image_id: string }) => {
  return request
    .post("/api/instance/image/delete", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 我的镜像列表
export const getMyMirrorList = (query: { page: number; size: number }) => {
  return request
    .post(
      "/api/instance/image/list",
      {},
      {
        params: query,
        headers,
      }
    )
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取邀请信息
export const getInviteList = () => {
  return request
    .post(
      "/api/user/invite/info",
      {},
      {
        headers,
      }
    )
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取账单明细-明细
export const getBillList = (
  query: {
    page: number;
    size: number;
  },
  params?: {
    date_from: string;
    date_to: string;
  }
) => {
  return request
    .post("/api/order/user/bill/list", params, {
      headers,
      params: query,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取账单明细-按日
export const getBillDay = (
  query: {
    page: number;
    size: number;
  },
  params?: {
    date_from: string;
    date_to: string;
  }
) => {
  return request
    .post("/api/order/user/bill/day", params, {
      headers,
      params: query,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取收支明细
export const getUserDetailList = (
  query: {
    page: number;
    size: number;
  },
  params?: {
    transaction_type: string;
    transaction_category: string;
    date_from: string;
    date_to: string;
  }
) => {
  return request
    .post("/api/order/user/transact/list", params, {
      headers,
      params: query,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 充值
export const postRecharge = (params: {
  amount: number;
  pay_channel: "wechat_web" | "wechat_h5" | "alipay" | "alipay_h5";
  subject: string;
}) => {
  return request
    .post("/api/order/user/recharge", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 查询实例
export const queryInstance = () => {
  return request
    .post("/api/dashboard/instance", null, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取佣金
export const getInviteUserList = () => {
  return Promise.resolve([
    {
      phone: "188******80",
      amount: "*96.29",
    },
    {
      phone: "151******09",
      amount: "*58.54",
    },
    {
      phone: "180******59",
      amount: "*35.17",
    },
    {
      phone: "189******89",
      amount: "*87.56",
    },
    {
      phone: "134******09",
      amount: "*68.59",
    },
    {
      phone: "150******61",
      amount: "*97.45",
    },
    {
      phone: "136******28",
      amount: "*53.23",
    },
    {
      phone: "134******07",
      amount: "*63.87",
    },
    {
      phone: "186******12",
      amount: "*38.18",
    },
    {
      phone: "156******79",
      amount: "*63.74",
    },
    {
      phone: "139******84",
      amount: "*86.28",
    },
    {
      phone: "180******65",
      amount: "*74.35",
    },
  ]);
};

// 查询用户告警
export const queryUserAlert = () => {
  return request
    .post("/api/user/setting/list", null, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 编辑用户告警
export const postUserAlert = (param: {
  instance_warning_status: 0 | 1;
  balance_warning_status: 0 | 1;
  balance_warning_money: number;
}) => {
  return request
    .post(
      "/api/user/setting/edit",
      {
        instance_notify_config: {
          instance_warning_status: param.instance_warning_status,
        },
        balance_notify_config: {
          balance_warning_status: param.balance_warning_status,
          balance_warning_money: param.balance_warning_money,
        },
      },
      {
        headers,
      }
    )
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 开启自定义服务
export const postCustomService = (param: { instance_id: string }) => {
  return request
    .post("/api/instance/custom/open", param, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 预览流量转换
export const getPreviewTransf = (param: { instance_id: string }) => {
  return postChangeTransf({ ...param, dry_run: true });
};

// 流量转换
export const postChangeTransf = (param: {
  instance_id: string;
  dry_run?: boolean;
}) => {
  const sendData = { ...param };
  sendData.dry_run = param.dry_run ? true : false;
  return request
    .post("/api/instance/prepay/change", sendData, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 更新用户信息
export const updateUserInfo = (param: {
  email?: string;
  invoice?: Record<string, string>;
  receiver?: Record<string, string>;
}) => {
  return request
    .post("/api/user/extra/update", param, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取用户信息
export const getUserInfo = () => {
  return request
    .post("/api/user/info", null, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取并刷新用户信息
export const syncUserInfo = (param: {
  email?: string;
  invoice?: Record<string, string>;
  receiver?: Record<string, string>;
}) => {
  return updateUserInfo(param).then(() => {
    return getUserInfo().then((userInfo) => {
      if (userInfo) {
        try {
          localStorage.setItem("user", JSON.stringify(userInfo));
        } catch (err) {
          console.error(err);
        }
      }
      return userInfo;
    });
  });
};

// 开发票
export const applyForInvoice = (param: { category: string; msg?: string }) => {
  return request
    .post("/api/user/invoice", param, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 获取用户发票列表
export const getUserInvoiceList = (
  query: {
    size: number;
    page: number;
  },
  params: {}
) => {
  return request
    .post("/api/user/invoice/list", params, {
      headers,
      params: query,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 用户重置发票状态
export const revoiceInvoiceStatus = (params: {
  id: string;
  msg: string;
  action: "Refresh" | "Cancel";
}) => {
  return request
    .post("/api/user/invoice/operate", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 存储统计
export const getStorageStat = (params: { region: string }) => {
  return request
    .post("/api/dashboard/storage", params, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// 首页价格
export const getGPURecommend = () => {
  return request
    .post("/api/market/home/machine")
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// aksk创建
export const postAksk = () => {
  return request
    .post("/api/user/aksk", {}, {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// aksk获取
export const getAksk = () => {
  return request
    .get("/api/user/aksk", {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};

// aksk删除
export const delAksk = () => {
  return request
    .delete("/api/user/aksk", {
      headers,
    })
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};


// 获取基础镜像列表
export const getMarketKvmList = () => {
  return request
    .post("/api/market/kvm/list")
    .then(handleResponse)
    .then(handleThenable)
    .catch(handleError);
};
